import React from "react";
import { useStyles } from "./leftBar.styles";
import gitImg from "../../assets/svgs/GitHub.svg";
import linkedIng from "../../assets/svgs/LinkedIn.svg";
import codingame from "../../assets/svgs/Xing.svg";

function LeftBar() {
  const styles = useStyles();
  return (
    <div className={styles.main}>
      <a
        href="https://github.com/FarahDvp"
        target="_blank"
        className={styles.logo}
      >
        <img src={gitImg} />
      </a>
      <a
        href="https://www.linkedin.com/in/farah-dridi-it-engineer/"
        target="_blank"
        className={styles.logo}
      >
        <img src={linkedIng} />
      </a>
      <a
        href="https://www.xing.com/profile/Farah_Dridi"
        target="_blank"
        className={styles.logo}
      >
        <img src={codingame} />
      </a>
      <span className="vertical-line" />
    </div>
  );
}

export default LeftBar;
